<template>
  <span></span>
</template>

<script>

export default {
  created () {
    this.barcode = ''
    this.timeoutHandler = null
  },
  mounted () {
    document.addEventListener('keypress', this.onKeypress)
  },
  beforeDestroy () {
    document.removeEventListener('keypress', this.onKeypress)
  },
  methods: {
    onKeypress (e) {
      this.barcode += e.key

      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler)
      }

      this.timeoutHandler = setTimeout(() => {
        if (this.barcode.length <= 5) {
          this.barcode = ''
          return
        }

        if (this.barcode.endsWith('Enter')) {
          this.barcode = this.barcode.slice(0, -5)
        }

        this.$emit('scan', this.barcode)
        this.barcode = ''
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BarcodeScanner.vue?78765624